import { render } from "./AddEditTreeGroupModal.vue?vue&type=template&id=54fada87&scoped=true&ts=true"
import script from "./AddEditTreeGroupModal.vue?vue&type=script&lang=ts"
export * from "./AddEditTreeGroupModal.vue?vue&type=script&lang=ts"

import "./AddEditTreeGroupModal.vue?vue&type=style&index=0&id=54fada87&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fada87"]])

export default __exports__